import { registerStore } from '../common';
import { MODULE_NAME } from './const';
import createStore from './store';
import { mutationTypes, getterTypes } from './store/types';
import { enableNavBarAction } from './utils/dom-helper';

registerStore(MODULE_NAME, { store: createStore() });
export { default as PublishLimitPopup } from './components/PublishLimitPopup.vue';
export {
  MODULE_NAME,
  mutationTypes,
  getterTypes,
  enableNavBarAction,
}
